import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'columnStatus',
  pure: true,
})
export class ColumnStatusPipe implements PipeTransform {
  transform(status: any): string {
    const statusString = String(status);

    return statusString.toLocaleLowerCase();
  }
}
